module.exports = __webpack_public_path__ + "static/media/fd_white_logo.9e86df63.svg";